var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gallery-title"},_vm._l((_vm.splitTitle),function(part,index){return _c('span',{key:("gallery-title-part-" + index),ref:"titleParts",refInFor:true,staticClass:"gallery-title__part"},[_vm._v(_vm._s(part))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }